import React, { useState } from 'react'

import './style.css'
import LoadingIndicator from 'src/components/LoadingIndicator'
import CustomCheckbox from 'src/components/CustomCheckbox'
import { useTranslation } from 'react-i18next'
import { NavButton } from '../navigation/nav'

export const Form = ({ onClose = () => {}, color }) => {
  const [loading, setLoading] = useState(false)
  const [agree, setAgree] = useState(false)
  const [successMessage, setSuccessMessage] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const [emailError, setEmailError] = useState(null)
  const [referError, setReferError] = useState(null)
  const [companyError, setCompanyError] = useState(null)
  const [agreeError, setAgreeError] = useState(null)

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [refer, setRefer] = useState('')
  const [employeesNumber, setEmployeesNumber] = useState('1-50')

  const { t } = useTranslation()

  const clearForm = () => {
    setFirstName('')
    setLastName('')
    setEmail('')
    setCompanyName('')
    setRefer('')
    setEmployeesNumber('')
    setAgree(false)
    setAgreeError(null)
  }

  const validateEmail = email => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }

  const handleSendForm = () => {
    if (!validateEmail(email)) {
      setEmailError(true)
    }
    if (!refer) {
      setReferError(true)
    }
    if (!companyName) {
      setCompanyError(true)
    }
    if (!agree) {
      setAgreeError(true)
    }
    if (validateEmail(email) && !!companyName && agree && !!refer) {
      setLoading(true)
      const data = {
        firstName,
        lastName,
        email,
        phoneNumber,
        companyName,
        referredBy: refer,
        employeesNumber,
        sourceUrl: window.location.href
      }
      fetch(window._env_.REACT_APP_API_HOST + '/v1/companies/demo-request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(response => {
        // console.log(response.status);
        if (response.status) {
          setLoading(false)
          clearForm()
          setSuccessMessage('Success! Data has been sent.')
          setTimeout(() => {
            onClose()
          }, 5000)
        } else {
          setLoading(false)
          setErrorMessage('Something went wrong, please try again')
        }
      })
    }
  }

  return (
    <div style={{ opacity: loading ? 0.5 : 1, position: 'relative', padding: '30px 30px' }} className='column signup'>
      {loading && (
        <div
          style={{
            position: 'absolute',
            background: '#ffffff40',
            width: 'calc( 100% - 60px)',
            height: 'calc( 100% - 160px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            boxSizing: 'border-box'
          }}
        >
          <LoadingIndicator />
        </div>
      )}
      {successMessage && (
        <div className='column column-center' style={{ justifyContent: 'center', height: '210px' }}>
          <svg
            style={{ marginBottom: '30px' }}
            width='100'
            height='100'
            viewBox='0 0 218 219'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g filter='url(#filter0_di_1_735)'>
              <mask id='path-1-inside-1_1_735' fill='white'>
                <path d='M16.8527 60.7004C16.8527 36.6364 36.3605 17.1286 60.4245 17.1286H157.623C181.687 17.1286 201.195 36.6364 201.195 60.7004V157.899C201.195 181.963 181.687 201.471 157.623 201.471H60.4246C36.3605 201.471 16.8527 181.963 16.8527 157.899V60.7004Z' />
              </mask>
              <path
                d='M16.8527 60.7004C16.8527 36.6364 36.3605 17.1286 60.4245 17.1286H157.623C181.687 17.1286 201.195 36.6364 201.195 60.7004V157.899C201.195 181.963 181.687 201.471 157.623 201.471H60.4246C36.3605 201.471 16.8527 181.963 16.8527 157.899V60.7004Z'
                fill='#2DC38C'
              />
              <path
                d='M16.8527 17.1286H201.195H16.8527ZM201.195 157.899C201.195 188.905 176.06 214.04 145.054 214.04H72.9933C41.9877 214.04 16.8527 188.905 16.8527 157.899C16.8527 175.022 36.3605 188.902 60.4245 188.902H157.623C181.687 188.902 201.195 175.022 201.195 157.899ZM16.8527 201.471V17.1286V201.471ZM201.195 17.1286V201.471V17.1286Z'
                fill='#2DC38C'
                mask='url(#path-1-inside-1_1_735)'
              />
            </g>
            <g filter='url(#filter1_d_1_735)'>
              <path
                d='M67.1279 100.71L89.0388 127.003C92.2454 130.851 98.0892 131.044 101.544 127.417L150.92 75.572'
                stroke='white'
                strokeWidth='16.7584'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <filter
                id='filter0_di_1_735'
                x='8.47351'
                y='-3.81942'
                width='201.101'
                height='213.67'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
              >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                  in='SourceAlpha'
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                  result='hardAlpha'
                />
                <feMorphology radius='8.3792' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_1_735' />
                <feOffset />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0.806057 0 0 0 0 0.943424 0 0 0 0 0.893056 0 0 0 0.3 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1_735' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1_735' result='shape' />
                <feColorMatrix
                  in='SourceAlpha'
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                  result='hardAlpha'
                />
                <feOffset dy='-20.948' />
                <feGaussianBlur stdDeviation='12.5688' />
                <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
                <feColorMatrix type='matrix' values='0 0 0 0 0.386074 0 0 0 0 0.918896 0 0 0 0 0.723528 0 0 0 1 0' />
                <feBlend mode='normal' in2='shape' result='effect2_innerShadow_1_735' />
              </filter>
              <filter
                id='filter1_d_1_735'
                x='25.2317'
                y='50.4344'
                width='167.584'
                height='138.238'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
              >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                  in='SourceAlpha'
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                  result='hardAlpha'
                />
                <feOffset dy='16.7584' />
                <feGaussianBlur stdDeviation='16.7584' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1_735' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1_735' result='shape' />
              </filter>
            </defs>
          </svg>

          <p
            style={{
              color: '#3F8367',
              marginBottom: 20,
              marginTop: -20,
              fontWeight: 600
            }}
          >
            {successMessage}
          </p>
        </div>
      )}
      {errorMessage && (
        <p
          style={{
            color: '#B70000',
            marginBottom: 20,
            marginTop: -20,
            fontWeight: 600
          }}
        >
          {errorMessage}
        </p>
      )}
      {!successMessage && (
        <>
          <label htmlFor='firstName'>Full Name</label>
          <input
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
            style={{ padding: '0px 20px' }}
            id='firstName'
            type='text'
          />

          <label htmlFor='email'>
            {t('Work email')}
            <span style={{ color: '#B70000' }}>*</span>
          </label>
          <input
            value={email}
            onChange={e => {
              setEmail(e.target.value)
              setEmailError(null)
            }}
            style={{ padding: '0px 20px' }}
            id='email'
            type='text'
          />
          {emailError && <p style={{ color: '#B70000', margin: '-15px 0px 20px 0px' }}>{t('Please check email')}</p>}
          <label htmlFor='phoneNumber'>{t('Phone number')}</label>
          <input
            value={phoneNumber}
            onChange={e => {
              setPhoneNumber(e.target.value)
            }}
            style={{ padding: '0px 20px' }}
            id='phoneNumber'
            type='text'
          />
          <label htmlFor='companyName'>
            {t('Company name')}
            <span style={{ color: '#B70000' }}>*</span>
          </label>
          <input
            value={companyName}
            onChange={e => {
              setCompanyName(e.target.value)
              setCompanyError(null)
            }}
            style={{ padding: '0px 20px' }}
            id='companyName'
            type='text'
          />
          {companyError && (
            <p style={{ color: '#B70000', margin: '-15px 0px 20px 0px' }}>{t('Company name is required')}</p>
          )}
          <label htmlFor='employeesAmount'>{t('Number of employees')}</label>
          {/* <input value={employeesNumber} onChange={e => setEmployeesNumber(e.target.value)} style={{ padding: '0px 20px' }} id="employeesAmount" type="text" /> */}
          <select
            value={employeesNumber}
            onChange={e => setEmployeesNumber(e.target.value)}
            style={{ padding: '0px 20px' }}
            id='employeesAmount'
            name='employeesNumber'
          >
            <option value='1-50'>1-50</option>
            <option value='51-100'>51-100</option>
            <option value='101-250'>101-250</option>
            <option value='251-1000'>251-1000</option>
            <option value='1000+'>1000+</option>
          </select>
          <label htmlFor='refer'>
            {t('Who referred you?')}
            <span style={{ color: '#B70000' }}>*</span>
          </label>
          <input
            value={refer}
            onChange={e => {
              setRefer(e.target.value)
              setReferError(null)
            }}
            style={{ padding: '0px 20px' }}
            id='refer'
            type='text'
          />
          {referError && <p style={{ color: '#B70000', margin: '-15px 0px 20px 0px' }}>{t('Field is requered')}</p>}
          {/* <p style={{ color: '#9999FE', lineHeight: '19px', fontSize: '12px', marginBottom: '40px' }}>
                <strong>Are you looking to become a partner/reseller?</strong> Please fill in the partner request form on our <a style={{ color: '#0157FF' }} target='_blank' href="/">partner page</a>.
                Cyberlift needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at anytime. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, check out our <a style={{ color: '#0157FF' }} target='_blank' href="/">Privacy Policy</a>.
              </p> */}
          <div className='row ' style={{ marginBottom: 20 }}>
            <CustomCheckbox
              checked={agree}
              onChange={() => {
                setAgree(!agree)
                setAgreeError(null)
              }}
            />
            <label
              htmlFor='consent'
              style={{
                margin: '0px 0px 0px 10px',
                lineHeight: 1.5,
                ...(agreeError && {
                  textDecorationLine: 'underline',
                  textDecorationStyle: 'wavy',
                  textDecorationColor: '#B70000'
                })
              }}
            >
              <p>
                {t('By clicking the button you agree')} <br /> {t('with our')}{' '}
                <a
                  target='_blank'
                  className='form-link'
                  href='https://www.ajg.com/uk/global-privacy-notice/'
                  rel='noreferrer'
                >
                  {t('Privacy Policy')}
                </a>
                <span style={{ color: '#B70000' }}>*</span>
              </p>
            </label>
          </div>
          <div className='text-center'>
            <NavButton color={color} fullwidth={true} onClick={handleSendForm} variant='dark' size='md'>
              Request a demo
            </NavButton>
          </div>
        </>
      )}
    </div>
  )
}
